<style lang="less" scoped>
@import "../assets/css/header.less";
.parseService {
  position: absolute;
}
</style>
<template>
  <section>
    <div class="header">
      <img style="display: none" src="../assets/images/nav.png" />
      <div class="logo">
        <h2 v-if="lang == 'en'"><img src="../assets/images/en.png" /></h2>
        <h2 v-else><img src="../assets/images/logo.png" /></h2>
      </div>
      <div class="switch" v-if="lang == 'en'">
        <a href="/phone/en" class="active" @click="handleChangeLang('en')"
          >EN</a
        >
        <a href="/" @click="handleChangeLang('zh')">中文</a>
      </div>
      <div class="switch" v-else>
        <a href="/phone/en" @click="handleChangeLang('en')">EN</a>

        <a class="active" href="/" @click="handleChangeLang('zh')">中文</a>
      </div>
      <div>
        <img
          @click="leftContent"
          class="menu"
          src="../assets/images/menu.png"
        />
      </div>
    </div>
    <div v-if="showMenu">
      <ComMenu></ComMenu>
    </div>
  </section>
</template>
<script>
import ComMenu from "./menu.vue";
export default {
  components: {
    ComMenu,
  },
  data() {
    return {
      basicContent: false,
      showMenu: false,
      i: 1,
      lists: [],
      lang: "",
      showLocales: [
        {
          name: "中文",
          label: "zh",
        },
        {
          name: "EN",
          label: "en",
        },
      ],
    };
  },

  // beforeCreate() {
  //   console.log(888)
  //   var link = window.location.href;

  //   if (link.indexOf("/en") != -1) {
  //     this.$cookie.set("lang", "en", {
  //       expires: "1h",
  //     });
  //   } else {
  //     this.$cookie.delete("lang");
  //   }
  // },
  mounted() {
    this.lang = this.$cookie.get("lang");
  },
  methods: {
    handleChangeLang(item) {
      this.$cookie.set("lang", item, "0", null);
      // this.$router.go(0);
    },
    handle_home() {
      this.$router.push({
        name: "Main",
      });
    },
    showPaper() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Paper",
        });
      } else {
        this.$router.push({
          name: "PaperEn",
        });
      }
    },
    leftContent() {
      if (this.i % 2 == 1) {
        this.showMenu = true;
        this.i++;
      } else {
        this.showMenu = false;
        this.i++;
      }
    },
    handle_company() {
      this.$router.push({
        name: "SearchList",
      });
    },
    handle_cold() {
      this.$router.push({
        name: "ServiceList",
      });
    },
    handle_member() {
      this.$router.push({
        name: "Member",
      });
    },
    handle_order() {
      this.$router.push({
        name: "Project",
      });
    },
    handle_news() {
      this.$router.push({
        name: "NewList",
      });
    },
    handle_about() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Intro",
        });
      } else {
        this.$router.push({
          name: "IntroEn",
        });
      }
    },
    handle_project() {
      this.$router.push({
        name: "NsfList",
      });
    },
  },
};
</script>

